import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge"

// Botones de acción en la barra nativa (hoy la lupa de la tienda): un item por link; lo nativo responde { index }
// en cada toque y acá se hace click en ese link. Doc: _docs/mobile/hotwire_native/brigde_component.md → Nav Actions
export default class extends BridgeComponent {
  static component = "nav-actions"
  static targets = ["item"]

  connect() {
    super.connect()
    const items = this.itemTargets.map(target => {
      const element = new BridgeElement(target)
      return {
        title: element.title,
        iosImage: element.bridgeAttribute("ios-image"),
        androidImage: element.bridgeAttribute("android-image")
      }
    })
    this.send("connect", { items }, message => {
      const item = this.itemTargets[message.data.index]
      if (item) new BridgeElement(item).click()
    })
  }

  disconnect() {
    this.send("disconnect")
    super.disconnect()
  }
}
